"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomString = exports.zodDate = exports.SHARED_WITH_MAX_LENGTH = exports.emailList = exports.normalizeEmailList = exports.EMAIL_LIST_REGEX = exports.zodNullToStringNonempty = exports.emptyStringToNull = exports.uuid = exports.errorify = void 0;
var zod_1 = require("zod");
var errorify = function (err) {
    if (err instanceof Error) {
        return err;
    }
    else {
        return new Error("Unknown error: ".concat(err));
    }
};
exports.errorify = errorify;
exports.uuid = zod_1.z
    .string()
    .regex(new RegExp(/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/));
exports.emptyStringToNull = zod_1.z.literal('').transform(function () { return null; });
exports.zodNullToStringNonempty = zod_1.z.preprocess(function (arg) {
    if (arg === null) {
        return '';
    }
    return arg;
}, zod_1.z.string().nonempty('commonErrors.empty'));
/**
 * A single e-mail address. Any top-level domain with at least two letters is accepted (e.g. ".energy").
 */
var EMAIL_PATTERN = '[\\w.%+-]+@(?:[\\w-]+\\.)+[A-Za-z]{2,}';
/**
 * One or more e-mail addresses separated by ", " (the format stored in the database).
 */
exports.EMAIL_LIST_REGEX = new RegExp("^".concat(EMAIL_PATTERN, "(?:, ").concat(EMAIL_PATTERN, ")*$"));
/**
 * Normalizes user input of a comma separated e-mail list: surrounding whitespace is removed
 * and every separator becomes ", " (e.g. "a@x.de ,b@y.de" -> "a@x.de, b@y.de").
 */
var normalizeEmailList = function (value) {
    return value
        .trim()
        .split(/\s*,\s*/)
        .join(', ');
};
exports.normalizeEmailList = normalizeEmailList;
/**
 * Schema for a comma separated list of e-mail addresses. Input is normalized before validation,
 * the parsed value is the normalized list.
 */
var emailList = function (_a) {
    var _b = _a === void 0 ? {} : _a, max = _b.max;
    return zod_1.z
        .string()
        .transform(exports.normalizeEmailList)
        .superRefine(function (value, ctx) {
        if (!exports.EMAIL_LIST_REGEX.test(value)) {
            ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, message: 'customerForm.errors.email' });
        }
        else if (max !== undefined && value.length > max) {
            ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, message: 'customerForm.errors.emailListTooLong' });
        }
    });
};
exports.emailList = emailList;
/**
 * Maximum length of StagingAggregator.sharedWith (database column size).
 */
exports.SHARED_WITH_MAX_LENGTH = 1000;
exports.zodDate = zod_1.z.preprocess(function (arg) {
    if (typeof arg == 'string' || arg instanceof Date) {
        return new Date(arg);
    }
}, zod_1.z.date({ required_error: 'commonErrors.selectDate' }));
/**
 * Pseudo-random string generator
 * http://stackoverflow.com/a/27872144/383904
 * Default: return a random alpha-numeric string
 *
 * @param {Integer} len Desired length
 * @param {String} an Optional (alphanumeric), "a" (alpha), "n" (numeric)
 * @return {String}
 */
function randomString(len, an) {
    if (an === void 0) { an = 'n'; }
    var type = an && an.toLowerCase();
    var str = '';
    var min = type == 'a' ? 10 : 0;
    var max = type == 'n' ? 10 : 62;
    for (var i = 0; i++ < len;) {
        var r = (Math.random() * (max - min) + min) << 0;
        str += String.fromCharCode((r += r > 9 ? (r < 36 ? 55 : 61) : 48));
    }
    return str;
}
exports.randomString = randomString;
